import React from 'react';
import { Modal, Input, Button } from 'antd';
import infoBlue from '../../../images/info-blue.png';
import infoGray from '../../../images/info-gray.png';
import infoPink from '../../../images/info-pink.png';
const { TextArea } = Input;

class ProjectInfoModal extends React.Component {
  state = {
    title: '',
    description: ''
  };

  getIcon = () => {
    if (this.props.color == '#006588') {
      return infoBlue;
    } else if (this.props.color == '#7c868d') {
      return infoGray;
    } else {
      return infoPink;
    }
  };

  componentDidUpdate = prevProps => {
    if (
      typeof this.props.open === 'object' &&
      prevProps.open !== this.props.open
    ) {
      this.setState({
        title: this.props.open.projectTitle,
        description: this.props.open.projectDescription
      });
    }
    if (!this.props.open && prevProps.open !== this.props.open) {
      this.setState({
        title: '',
        description: ''
      });
    }
  };

  render() {
    const { t, color } = this.props;

    const styles = {
      titleDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 20
      },
      title: {
        marginBottom: 0,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        color: color
      },
      button: {
        backgroundColor: color,
        color: 'white',
        border: 'none',
        borderRadius: '20px',
        width: '48%',
        marginTop: 20
      },
      cancelButton: {
        backgroundColor: 'white',
        color: color,
        border: `1px solid ${color}`,
        borderRadius: '20px',
        width: '48%',
        marginTop: 20
      }
    };

    return (
      <Modal
        visible={this.props.open}
        onCancel={this.props.close}
        footer={false}>
        <div style={styles.titleDiv}>
          <h3 style={styles.title}>{t('Project Name')}</h3>
        </div>
        <TextArea
          onChange={e => this.setState({ title: e.target.value })}
          value={this.state.title}
          style={{ marginTop: 10, border: `1px solid ${color}` }}
        />
        <div style={styles.titleDiv}>
          <h3 style={styles.title}>{t('Project Description')}</h3>
        </div>
        <TextArea
          onChange={e => this.setState({ description: e.target.value })}
          rows={4}
          value={this.state.description}
          style={{ marginTop: 10, border: `1px solid ${color}` }}
        />
        <div style={styles.titleDiv}>
          <Button
            style={styles.cancelButton}
            onClick={() => this.props.close()}>
            {t('Cancel')}
          </Button>
          <Button
            style={styles.button}
            onClick={() =>
              this.props.addProject(this.state.title, this.state.description)
            }
            disabled={this.state.title == '' || this.state.description == ''}>
            {typeof this.props.open === 'object' ? t('Save') : t('Next')}
          </Button>
        </div>
      </Modal>
    );
  }
}

export default ProjectInfoModal;



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/projectInfoModal.js